<template>
  <div class="modal-container hide-desktop" v-if="visible">
    <div class="modal">
      <a @click="hideModal"
        ><v-icon name="times" scale="1.6" class="modal__close-icon"
      /></a>
      <p class="modal__title">{{ $t("download the app") }}</p>
      <p class="modal__text">
        {{
          $t(
            "for more efficient work, we recommend that you download our mobile application"
          )
        }}
      </p>
      <div class="row justify-around">
        <a
          href="https://play.google.com/store/apps"
          target="_blank"
          class="modal__icon"
          ><img src="@/assets/images/android_icon.svg" alt="Логотип Apple"
        /></a>
        <a
          href="https://www.apple.com/ru/itunes/charts/free-apps/"
          target="_blank"
          class="modal__icon"
          ><img src="@/assets/images/apple_icon.svg" alt="Логотип Apple"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons";
import Icon from "vue-awesome/components/Icon";

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    "v-icon": Icon
  },
  methods: {
    hideModal() {
      this.$emit("hideModal");
    }
  }
};
</script>

<style scoped>
.modal {
  width: 80%;
  min-height: 200px;
}

.modal__text {
  margin: 20px 0;
  font-size: 15px;
}

.modal__icon {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.modal__icon > img {
  width: 50px;
}
</style>
